module.exports = __webpack_public_path__ + "src/assets/img/menu_icon_7.ae44e6cf.svg";